<template>
    <div ref="container">
        <a-modal 
            :title="title" 
            width="95%" 
            :visible="visible" 
            :confirmLoading="confirmLoading" 
            :maskStyle="{'top':'93px','left':'154px'}" 
            :maskClosable="false" 
            @ok="handleOk" 
            @cancel="handleCancel"
            @close="closeModal" 
            cancelText="关闭" 
            style="top:50px;height: 90%;"
        >
            <a-table
                ref="table"
                size="middle"
                bordered
                rowKey="uuid"
                :columns="columns"
                :dataSource="dataSource"
                :pagination="eventIpagination"
                @change="handleEventChange">
                
                <span slot="action" slot-scope="text, record">
                    <a @click="getCodeInfo(record)">码详情</a>
                    <a-divider type="vertical" v-if="record.uploadFile" />
                    <a v-if="record.uploadFile" @click="getErrorInfo(record)" style="margin-left: 8px">异常记录</a>
                    <a-divider type="vertical" v-if="record.uploadRemark"/>
                    <a v-if="record.uploadRemark && record.uploadRemark.includes('存在已出库码')" @click="quicklyReturn(record)" style="margin-left: 8px">快速退货</a>
                    <a-divider type="vertical" v-if="record.uploadRemark"/>
                    <a v-if="record.uploadRemark && record.uploadRemark.includes('快速退货成功')" @click="getRawData(record)" style="margin-left: 8px">出库</a> 
                </span>
            </a-table>
            <Get-Code-Info ref="getCode" ok="getCodeOk" close="getCodeClose"></Get-Code-Info>
        </a-modal>
    </div>
</template>
<script>
import GetCodeInfo from './getCodeInfo';
import { getUploadMessages, returnGoodsForReceiveOut, getUploadDetails, receiveOutReturn } from '@/api/api'
export default {
    name: '码详情',
    components: {
        GetCodeInfo
    },
    data () {
        return {
            title: '出库列表',
            visible: false, 
            detailVisible: false, 
            traceDetailVisible: false, 
            confirmLoading: false,
            originalImageVisible: false,
            originalImageUrl: '',
            processId: '',
            selectedItem: {},
            details: [],
            model: {},
            getOutStock: null,
            isStock: false,
            labelCol: {
                xs: { span: 24 },
                sm: { span: 5 },
            },
            wrapperCol: {
                xs: { span: 24 },
            },
            dataSource:[],
            traceDetails:[],
            columns: [
                {
                    title: '序号',
                    dataIndex: '',
                    key:'rowIndex',
                    width: '5%',
                    align:"center",
                    customRender:function (t,r,index) {
                        return parseInt(index)+1;
                        //  return (this.ipagination.current - 1) * this.ipagination.pageSize + index + 1;
                    }
                },
                { title: '创建时间', dataIndex: 'createTime', },
                // { title: '单据编号', dataIndex: 'billNo', },
                { title: '扫码数量', dataIndex: 'scanNum', },
                { title: '处理结果', dataIndex: 'uploadRemark', },
                {
                    title: '操作',
                    dataIndex: 'action',
                    width: 350,
                    align:"center",
                    scopedSlots: { customRender: 'action' },
                },
                
            ],
            ipagination: {
                current: 1,
                pageSize: 10,
                pageSizeOptions: ['10', '20', '30'],
                showTotal: (total, range) => {
                    return range[0] + '-' + range[1] + ' 共' + total + '条'
                },
                showQuickJumper: true,
                showSizeChanger: true,
                total: 0
            },
            eventIpagination: {
                current: 1,
                pageSize: 10,
                pageSizeOptions: ['10', '20', '30'],
                showTotal: (total, range) => {
                    return range[0] + '-' + range[1] + ' 共' + total + '条'
                },
                showQuickJumper: true,
                showSizeChanger: true,
                total: 0,
                billNo: '',
            },
        }
    },
    computed: {
       
    },
    methods: {
        show(e){
            this.visible = true
            console.log(e,'e===================')
            this.billNo = e.number
            this.getList()
        },
        async getList(){
            const params = {
                billNo: this.billNo,
                pageNo: this.eventIpagination.current,
                pageSize: this.eventIpagination.pageSize,
                uploadType: 5
            }
            const res = await getUploadMessages(params)
            if( res.code == 200 && res.success == true ){
                this.dataSource = res.result.records
            }
        },
        // 快速退货
        async quicklyReturn(record){
            const res = await returnGoodsForReceiveOut({id: record.id })
            if( res.code == 200 && res.success == true ){
                this.$message.success(res.message)
                // 获取原始数据
                this.getRawData(record)
            } else {
                this.$message.error(res.message)
            }
        },
        // 获取原始数据
        async getRawData(record){
            const res = await getUploadDetails({id: record.id })
            if( res.code == 200 && res.success == true ){
                this.$message.success(res.message)
                this.getOutStock = res.result
                this.outStock(record)
            } else {
                this.$message.error(res.message)
            }
        },
        // 出库退货
        async outStock(record){
            const params = {
                logId: record.id,
                billRecord: this.getOutStock.billRecord,
                billDetailRecords: this.getOutStock.billDetailRecords,
                billCodeRecords: this.getOutStock.billCodeRecords,
            }
            const res = await receiveOutReturn(params)
            if( res.code == 200 && res.success == true ){
                this.$message.success(res.message)
                // 关闭弹窗
                this.visible = false
                this.getList()
            } else {
                this.$message.error(res.message)
            }
        },
        // 查看所有码信息
        getCodeInfo(e){
            this.$refs.getCode.show(e, true)
        },
        getErrorInfo(e){
            this.$refs.getCode.show(e, false)
        },
        handleOk() {
          this.visible = false;
        },
        handleCancel(){
          this.visible = false;
        },
        closeModal(){
          this.visible = false;
        },
        getCodeOk(){

        },
        getCodeClose(){

        },
        handleEventChange(pagination, filters, sorter) {
            this.eventIpagination.current = pagination.current;
            this.eventIpagination.pageSize = pagination.pageSize;

            // 如果需要处理排序或过滤，可以在这里添加逻辑
            this.getTraceList(this.processId);
        },
        
    }
}
</script>
<style lang="less" scoped>

</style>